import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import PropTypes from 'prop-types';
import React from 'react';

export function SelectActivityField(props) {
  const { input, label, options, required, disabled, helperText, meta } = props;

  const selected = options.find((o) => String(o.value) === String(input.value)) || null;

  const visibleOptions = options.filter(
    (o) => !o.disabled || (selected && o.value === selected.value)
  );

  return (
    <FormControl
      variant="outlined"
      color="primary"
      style={{ width: '100%', marginTop: 16, marginBottom: 8 }}
      error={!!(meta && meta.touched && meta.error)}
      required={required}
      disabled={Boolean(disabled)}>
      <Autocomplete
        options={visibleOptions}
        value={selected}
        disabled={Boolean(disabled)}
        onChange={(_event, option) => input.onChange(option ? option.value : null)}
        getOptionLabel={(option) => String(option.label ?? '')}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        noOptionsText="Nenhuma atividade encontrada"
        clearOnEscape
        fullWidth
        renderInput={(params) => (
          <TextField {...params} variant="outlined" label={label} required={required} />
        )}
      />
      <input type="hidden" name={input.name} value={input.value ?? ''} readOnly />
      {meta && meta.touched && meta.error ? (
        <FormHelperText>{meta.error || helperText}</FormHelperText>
      ) : null}
    </FormControl>
  );
}

SelectActivityField.propTypes = {
  disabled: PropTypes.any,
  helperText: PropTypes.any,
  input: PropTypes.shape({
    name: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.any,
  }),
  label: PropTypes.any,
  meta: PropTypes.shape({
    error: PropTypes.any,
    touched: PropTypes.any,
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      disabled: PropTypes.bool,
      label: PropTypes.any,
      value: PropTypes.any,
    })
  ),
  required: PropTypes.any,
};
